import TextInput from "components/TextInput";
import styled, { css } from "styled-components";

export const SelectWrapper = styled.div<{
    /** Min width in px/rem/% (1rem = 10px)*/
    minWidth?: string;
    /** Max width in px/rem/% (1rem = 10px)*/
    maxWidth?: string;
    /** Takes full width of the parent component */
    fullWidth?: boolean;
    areOptionsVisible?: boolean;
    disabled?: boolean;
}>`
    position: relative;
    display: ${({ fullWidth }) => (fullWidth ? "flex" : "inline-flex")};
    min-width: ${({ minWidth }) => minWidth};
    max-width: ${({ maxWidth }) => maxWidth};
    width: ${({ fullWidth }) => fullWidth && "100%"};
    cursor: pointer;
    ${({ areOptionsVisible }) =>
        areOptionsVisible &&
        css`
            ${TextInput.Style} {
                border-bottom-left-radius: 0;
                border-bottom-right-radius: 0;

                #textInput-inner-wrapper {
                    border-bottom-left-radius: 0;
                    border-bottom-right-radius: 0;
                }
            }
        `}

    ${TextInput.Style} {
        input {
            cursor: pointer;
            user-select: none;
            &::selection {
                background: transparent;
            }
            &:disabled {
                cursor: not-allowed;
            }
        }
    }
`;
